// ========== 货币配置 ==========
const CURRENCY_CONFIG = {
  'USD': { symbol: '$',   rate: 1.00 },
  'EUR': { symbol: '€',   rate: 0.86 },
  'GBP': { symbol: '£',   rate: 0.74 },
  'AUD': { symbol: 'A$',  rate: 1.40 },
  'CAD': { symbol: 'C$',  rate: 1.37 },
  'JPY': { symbol: '¥',   rate: 159.20 },
  'SGD': { symbol: 'S$',  rate: 1.27 },
  'HKD': { symbol: 'HK$', rate: 7.83 }
};

const COUNTRY_TO_CURRENCY = {
  'US': 'USD', 'CA': 'CAD', 'GB': 'GBP', 'AU': 'AUD',
  'DE': 'EUR', 'FR': 'EUR', 'IT': 'EUR', 'ES': 'EUR', 'NL': 'EUR', 'BE': 'EUR', 'AT': 'EUR',
  'JP': 'JPY', 'SG': 'SGD', 'HK': 'HKD', 'CN': 'USD'
};

// ========== 核心功能 ==========
function getCurrentCurrency() {
  return localStorage.getItem('selectedCurrency') || 'USD';
}

function convertPrice(usdPrice, targetCurrency) {
  const config = CURRENCY_CONFIG[targetCurrency];
  if (!config) return usdPrice;
  
  const converted = usdPrice * config.rate;
  return targetCurrency === 'JPY' ? Math.round(converted) : converted.toFixed(2);
}

function formatPrice(amount, currency) {
  const config = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG['USD'];
  return `${config.symbol}${amount}`;
}

function convertAllPrices() {
  const currency = getCurrentCurrency();
  
  document.querySelectorAll('.money').forEach(el => {
    if (!el.dataset.usdPrice) {
      const text = el.textContent.trim();
      const price = parseFloat(text.replace(/[^0-9.]/g, ''));
      if (price > 0) {
        el.dataset.usdPrice = price;
      }
    }
    
    if (el.dataset.usdPrice) {
      const usdPrice = parseFloat(el.dataset.usdPrice);
      const converted = convertPrice(usdPrice, currency);
      el.textContent = formatPrice(converted, currency);
    }
  });
  
  console.log(`✅ 价格已转换为 ${currency}`);
}

// ========== 监听国家选择器 ==========
function attachCountrySelectorListeners() {
  // 方法1：监听所有 localization-form 内的链接
  document.querySelectorAll('localization-form a[data-value]').forEach(link => {
    link.addEventListener('click', function(e) {
      const countryCode = this.dataset.value;
      const currency = COUNTRY_TO_CURRENCY[countryCode] || 'USD';
      localStorage.setItem('selectedCurrency', currency);
      console.log(`🌍 国家切换: ${countryCode} → 货币: ${currency}`);
      
      // 延迟转换，等待页面刷新
      setTimeout(() => {
        convertAllPrices();
      }, 100);
    });
  });
  
  // 方法2：监听表单提交
  document.querySelectorAll('localization-form form').forEach(form => {
    form.addEventListener('submit', function(e) {
      const input = this.querySelector('input[name="country_code"]');
      if (input && input.value) {
        const countryCode = input.value;
        const currency = COUNTRY_TO_CURRENCY[countryCode] || 'USD';
        localStorage.setItem('selectedCurrency', currency);
        console.log(`🌍 表单提交: ${countryCode} → 货币: ${currency}`);
      }
    });
  });
  
  console.log('🎯 国家选择器监听已绑定');
}

// ========== 初始化 ==========
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  console.log('💱 货币转换器已加载');
  
  // 初始转换
  setTimeout(() => convertAllPrices(), 500);
  
  // 绑定国家选择器
  setTimeout(() => attachCountrySelectorListeners(), 1000);
  
  // 监听动态内容
  const observer = new MutationObserver((mutations) => {
    let shouldConvert = false;
    
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('money')) {
            shouldConvert = true;
          }
          if (node.querySelector && node.querySelector('.money')) {
            shouldConvert = true;
          }
          // 重新绑定新加载的选择器
          if (node.querySelector && node.querySelector('localization-form')) {
            attachCountrySelectorListeners();
          }
        }
      });
    });
    
    if (shouldConvert) {
      setTimeout(() => convertAllPrices(), 100);
    }
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
}

// 页面加载后转换
window.addEventListener('load', () => {
  setTimeout(() => convertAllPrices(), 200);
});
